// executeFlowConstants.js
// Extracted from ExecuteFlowShell.jsx — shared by all Execute sub-components

export const SCREEN_ORDER = [
  'execute.readiness_gate',
  'execute.calculation_run_initiator',
  'execute.calculation_run_monitor',
  'execute.payout_results',
  'execute.statement_batch',
  'execute.payroll_export',
]
